module.exports = __webpack_public_path__ + "img/screenshot-3.b0792e2a.png";